import React from 'react'
import { cn } from '../helpers/classnames'

const BUTTON_BASE_CLASS_OVERRIDE = 'rounded-none'

const classNameFromIdx = (idx: number, length: number) => {
  if (idx === 0) {
    return 'rounded-l-md border-r-0'
  }
  if (length - 1 === idx) {
    return 'rounded-r-md border-l-0'
  }
  return ''
}

const renderChildren = (children: React.ReactNode) => {
  const length = React.Children.count(children)

  return React.Children.map(children, (child, idx) => {
    if (!React.isValidElement(child)) return child

    const element = child as React.ReactElement<
      React.ButtonHTMLAttributes<HTMLButtonElement>
    >

    return React.cloneElement(element, {
      type: 'button',
      className: cn(
        element.props.className ?? '',
        BUTTON_BASE_CLASS_OVERRIDE,
        classNameFromIdx(idx, length)
      ),
    })
  })
}

export function ButtonGroup({
  children,
  ...rest
}: { children: React.ReactNode } & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>) {
  return (
    <span
      className={cn(
        'isolate inline-flex rounded-lg overflow-hidden [&>*:not(:last-child):not(:first-child)]:-ml-[1px] [&>*]:shadow-none dark:[&>*:not(:last-child)]:border-r-0',
        rest.className
      )}
    >
      {renderChildren(children)}
    </span>
  )
}
